import PriceRangeProvider from './PriceRangeProvider';

export default PriceRangeProvider;
